<div class="workspace-tab-panel w-100">
  <header class="workspace-section-head mb-4 text-start">
    <h1 class="mb-1">Proba Analytics</h1>
    <p class="mb-0">Upload data, generate dashboards, and automate analysis for faster decisions.</p>
  </header>

  <div class="workspace-card-grid w-100">
    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-rose d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-table gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Upload Data</h2>
          <p class="mb-0">Instant Analysis</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Upload CSV, Excel, or system data. Proba Analytics structures, validates, and analyzes your data for quick insights.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('file')">
        Upload Data <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-sky d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-chart-line gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Build Custom Dashboards</h2>
          <p class="mb-0">KPIs & Reporting</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Create interactive dashboards with your own KPIs, charts, and segmentation for executive and operational teams.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('dashboard')">
        Build Dashboard <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-purple d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-book gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Advanced Data Analysis</h2>
          <p class="mb-0">Trends & Insights</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Identify trends, risks, opportunities, and performance gaps using AI-powered analytics tools.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('analysis')">
        Analyze Data <span aria-hidden="true">&rarr;</span>
      </button>
    </article>
  </div>
</div>
